<script setup lang="ts">
import { type PropType } from 'vue'
import { vTooltip } from 'floating-vue'
import BsCollapse from '@/legacy/components/Collapse.vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

defineProps({
	pageContent: {
		type: Object as PropType<{
			[key: string]: string
		}>,
		required: true,
	},
	listIntro: {
		type: Object as PropType<
			{
				title: string
				content: string
				tooltip?: string
				action?: () => void
			}[]
		>,
		required: true,
	},
	description: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<section
		class="flex flex-col gap-20px rounded-lg border border-n-100 px-16px py-20px"
	>
		<div class="typography-s1-emp">
			{{ pageContent.detail_item_title }}
		</div>

		<div class="grid grid-cols-1 gap-good-friends mdp:grid-cols-2">
			<template v-for="item in listIntro">
				<div v-if="item.content">
					<div class="flex items-center gap-4px">
						<div class="typography-c2-reg mb-[2px] text-n-500">
							{{ item.title }}
						</div>

						<div
							class="h-16px w-16px cursor-pointer select-none"
							v-if="item.tooltip"
						>
							<BaseIcon
								v-tooltip="{
									content: item.tooltip,
									placement: 'top',
									popperClass:
										'max-w-[300px] whitespace-pre-line !z-0 bg-black rounded-lg',
									autoHide: true,
									distance: 8,
									triggers: ['click'],
								}"
								name="suggest-Info"
								class="h-full w-full text-o-500"
								@click="item.action"
							></BaseIcon>
						</div>
					</div>
					<div class="typography-s2-emp text-n-800">
						{{ item.content }}
					</div>
				</div>
			</template>
		</div>

		<span class="h-[1px] w-full bg-n-100"></span>
		<BsCollapse
			v-if="description"
			:isShowIcon="false"
			:clampLineHeightUnit="24"
			:numberOfClampLines="10"
			:buttonMoreText="pageContent.detail_button_view_more"
			:buttonLessText="pageContent.detail_button_view_less"
		>
			<template #content>
				<div class="typography-b3-reg whitespace-pre-line">
					{{ description }}
				</div>
			</template>
		</BsCollapse>
	</section>
</template>
